import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { SectionHeading } from "@/accounts-payable/common";
import type { ApVendor } from "@/accounts-payable/types";

/**
 * The vendor's ServiceTitan link. Unlinked, it says what's missing and why it
 * matters; linked, the ST name and id (there is no ServiceTitan vendor URL to
 * link to — see API.md).
 */
export const ServiceTitanSection = ({ vendor }: { vendor: ApVendor }) => (
  <Stack className="w-full" align="start" gap={2}>
    <SectionHeading>ServiceTitan</SectionHeading>
    {vendor.st_vendor_id ? (
      <Stack direction="row" gap={2} align="baseline" className="flex-wrap">
        <Text>{vendor.st_vendor_name}</Text>
        <Text tone="muted">#{vendor.st_vendor_id}</Text>
      </Stack>
    ) : (
      <Text tone="muted">
        Not linked to a ServiceTitan vendor yet. Invoices can’t sync until it
        is.
      </Text>
    )}
  </Stack>
);
